"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var AccordionDetailsRow = (0, styles_1.styled)(AccordionDetails_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: 0,
        '[class*="-row"] > .stickyCell:first-of-type': {
            marginRight: theme.spacing(0.5),
            paddingLeft: theme.spacing(3),
        },
    });
});
exports.default = AccordionDetailsRow;
